/**
 * Return a new array with `item` toggled: removed if present, appended if not.
 *
 * @param arr - current array
 * @param item - element to toggle
 * @returns new array with the item toggled
 */
export function toggleArrayItem<T>(arr: readonly T[], item: T): T[] {
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
}
